import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationComponent } from './validation.component';
import { HeaderComponent } from './header/header.component';
import { SummaryTableComponent } from './summary-table/summary-table.component';
import { RuleDetailsComponent } from './rule-details/rule-details.component';
import { UiKitModule } from '@o3/ui-kit';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ValidationRoutingModule } from './validation-routing.module';
import { PostPayloadComponent } from './post-payload/post-payload.component';

@NgModule({
  declarations: [
    ValidationComponent,
    HeaderComponent,
    SummaryTableComponent,
    RuleDetailsComponent,
    PostPayloadComponent,
  ],
  imports: [
    CommonModule,
    ValidationRoutingModule,
    UiKitModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class ValidationModule {}
